import { Modal, SxProps } from "@mui/material";
import { ModalContent } from "../../components/ModalBasic/style";

type IModalBasic = {
    open: boolean;
    handleClose: () => void;
    children: JSX.Element;
    sxProps?: SxProps
    sxModalContent?: SxProps
    avoidMobileSetting?: boolean
}


export function CommonModal({ 
  open,
  handleClose,
  children,
  sxProps,
  sxModalContent,
  avoidMobileSetting=false }: IModalBasic) {

  return (
    <Modal
      open={ open }
      onClose={ handleClose }
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={ {
        zIndex: 1400,
        width: "fit-content",
        ...sxProps
      } }
    >
      <ModalContent
        avoidMobileSetting={ avoidMobileSetting }
        sx={ {
          ...sxModalContent
        } }
      >
        { children }
      </ModalContent>
    </Modal>
  );
}
